export const DEALS_TABLE_REQUEST = "DEALS_TABLE_REQUEST";
export const DEALS_TABLE_SUCCESS = "DEALS_TABLE_SUCCESS";
export const DEALS_TABLE_FAIL = "DEALS_TABLE_FAIL";

export const PEOPLE_BASIC_DEAL_DETAILS_REQUEST =
  "PEOPLE_BASIC_DEAL_DETAILS_REQUEST";
export const PEOPLE_BASIC_DEAL_DETAILS_SUCCESS =
  "PEOPLE_BASIC_DEAL_DETAILS_SUCCESS";
export const PEOPLE_BASIC_DEAL_DETAILS_FAIL = "PEOPLE_BASIC_DEAL_DETAILS_FAIL";
